var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCpu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0-.42-.33-.75-.75-.75H20v-2.2h1.25c.42 0 .75-.33.75-.75 0-.41-.33-.75-.75-.75h-1.48a4.975 4.975 0 0 0-3.32-3.32V2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75V4h-2.2V2.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75V4H9.06V2.75a.749.749 0 1 0-1.5 0v1.48a4.97 4.97 0 0 0-3.33 3.32H2.75a.749.749 0 1 0 0 1.5H4v2.2H2.75a.749.749 0 1 0 0 1.5H4v2.2H2.75a.749.749 0 1 0 0 1.5h1.48a4.95 4.95 0 0 0 3.33 3.32v1.48a.749.749 0 1 0 1.5 0V20h2.2v1.25a.749.749 0 1 0 1.5 0V20h2.19v1.25c0 .41.34.75.75.75s.75-.34.75-.75v-1.48a4.975 4.975 0 0 0 3.32-3.32h1.48c.42 0 .75-.34.75-.75 0-.42-.33-.75-.75-.75H20v-2.2h1.25c.42 0 .75-.34.75-.75zm-7.74 5.26H9.74c-1.65 0-3-1.35-3-3V9.74c0-1.65 1.35-3 3-3h4.52c1.65 0 3 1.35 3 3v4.52c0 1.65-1.35 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.99 16.248c1.25 0 2.27-1.01 2.27-2.27v-3.97c0-1.25-1.01-2.27-2.27-2.27h-3.97c-1.25 0-2.27 1.01-2.27 2.27v3.97c0 1.26 1.01 2.27 2.27 2.27h3.97z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCpu);
export default __webpack_public_path__ + "static/media/vuesax-bold-cpu.35565d6665a3c2edf3108b16e925cde3.svg";
export { ForwardRef as ReactComponent };